import React from 'react';
import { Icon } from './Icon.js';
export const IconNecktie = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10 7H14", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M7 18L10 6.5L8.5 3C10.6688 1.7607 13.3312 1.7607 15.5 3L14 6.5L17 18L12 22.5L7 18Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconNecktie.js.map